module.exports = __webpack_public_path__ + "media/images/athletes/154-9c8e82e7727be0512da0ae305326a67f.png";